import styled from "styled-components";

import { Box, FlexSection } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledLeftSection = styled(FlexSection)`
  flex: 1;
  flex-direction: column;
  gap: 32px;

  @media only screen and (max-width: 600px) {
    gap: 0px;
  }
`;

export const ConditionTextContainer = styled(Box)`
  @media only screen and (max-width: 601px) {
    display: none;
  }
`;
export const StyledConditionsLink = styled(Typography)`
  font-size: 14px;
  line-height: 24px;
  font-family: var(--man-500);
  color: ${theme.colorsV2.gray.shade_800};
  a {
    color: ${theme.colors.link_color};
  }
  @media only screen and (max-width: 600px) {
    letter-spacing: 0.4px;
    text-align: center;
  }
`;
